export const toMoneyFormat = (value: number, addCurrencyPostfix = false) => {
  if (!value) return addCurrencyPostfix ? "0,00 PLN" : "0,00";

  if (addCurrencyPostfix) {
    return `${value.toFixed(2).replace(".", ",")} PLN`;
  }

  return value.toFixed(2).replace(".", ",");
};
